export async function shareLink({ url, title, text }) {
  if (navigator.share) {
    try {
      await navigator.share({ url, title, text });
      return 'shared';
    } catch { return 'cancelled'; }
  }
  await navigator.clipboard.writeText(url);
  return 'copied';
}
